// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__26GbF","rightAdornment":"Header_rightAdornment__2zn90"};